(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["essaro-faq-helpdesk"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('essaro-helpdesk')) {
  customElements.define('essaro-helpdesk', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('input[type="search"]');
      this.groups = Array.from(this.querySelectorAll('.eh__group'));
      this.categories = Array.from(this.querySelectorAll('[data-category]'));
      this.empty = this.querySelector('.eh__empty');
      this.status = this.querySelector('.eh__status');
      this.active = this.groups[0]?.id;
      if (!this.active) return;
      this.querySelector('.eh__search')?.removeAttribute('hidden');
      this.categories.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.active = link.dataset.category;
        if (this.input) this.input.value = '';
        this.filter();
      }, options));
      this.input?.addEventListener('input', () => this.filter(), options);
      this.input?.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.value = ''; this.filter(); }
      }, options);
      this.querySelector('.eh__clear')?.addEventListener('click', () => {
        if (this.input) { this.input.value = ''; this.filter(); this.input.focus(); }
      }, options);
      this.onBlockSelect = event => {
        const block = Array.from(this.querySelectorAll('[data-block-id]')).find(node => node.dataset.blockId === event.detail.blockId);
        if (!block) return;
        const group = block.closest('.eh__group');
        this.active = group.id;
        if (this.input) this.input.value = '';
        this.filter();
        if (block.matches('details')) block.open = true;
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect, options);
      const hashGroup = this.groups.find(group => '#' + group.id === window.location.hash);
      if (hashGroup) this.active = hashGroup.id;
      this.filter();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.bound = false;
    }
    filter() {
      const query = (this.input?.value || '').trim().toLocaleLowerCase();
      let total = 0;
      this.groups.forEach(group => {
        let matches = 0;
        group.querySelectorAll('.eh__item').forEach(item => {
          const match = !query || item.textContent.toLocaleLowerCase().includes(query);
          item.hidden = !match;
          if (match) matches++;
        });
        group.hidden = query ? matches === 0 : group.id !== this.active;
        total += matches;
      });
      this.categories.forEach(link => {
        if (!query && link.dataset.category === this.active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      this.empty.hidden = !query || total > 0;
      this.empty.querySelector('[data-query]').textContent = this.input?.value.trim() || '';
      this.status.textContent = query ? this.dataset.resultLabel.replace('[count]', total) : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
